import { useMutation, useQueryClient } from '@tanstack/react-query';
import useToast from '../useToast';
import { revokePeerSupportLeadPost } from '@/services/api/requests/organization';
import { TCustomAxiosError } from '@/services/api';
import { useAppStore } from '@/store/useAppStore';
import queryKeys from '@/constants/queryKeys';

const usePeerSupportLeadRevoke = (onSuccessCallback?: () => void) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { organization } = useAppStore();

  const { isPending, mutate } = useMutation({
    mutationFn: async (userId: string) => {
      const organizationId = organization?._id;

      if (!organizationId) throw Error('No Organization ID');

      const response = await revokePeerSupportLeadPost(organizationId, userId);

      return response;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.organization.members] });

      onSuccessCallback?.();

      toast({
        status: 'success',
        title: 'Success',
        description: 'Peer Support Lead revoking successful!',
      });

      return;
    },
    onError: (error: TCustomAxiosError) => {
      toast(
        {
          title: 'Error while revoking Peer Support Lead to Peer Support.',
        },
        error,
      );
    },
  });

  return { isPending, mutate };
};

export default usePeerSupportLeadRevoke;
